export default __webpack_public_path__ + "static/media/goldenBearArmor.725e4fcf.gif";